/** Data export and account closure in the merchant Admin (docs/specs/account-closure.md, SA-20). */
export const account = {
    title: "Data & account",
    description: "Download everything this business has stored, or close the account.",
    export: {
        title: "Export all data",
        body: "A ZIP file with one spreadsheet (CSV) per table — products, stock, sales, customers, accounts and more — plus uploaded files. It opens in Excel and keeps Bengali text. Passwords and API credentials are never included.",
        start: "Prepare export",
        started: "Preparing your export. It can take a few minutes.",
        history: "Exports",
        empty: "No exports yet.",
        status: {
            queued: "Waiting",
            running: "Preparing",
            done: "Ready",
            failed: "Failed",
            expired: "Expired",
        },
        summary: "{{tables}} tables · {{rows}} rows · {{files}} files · {{size}}",
        skipped_one: "{{count}} file was too large to include (listed in manifest.json).",
        skipped_other: "{{count}} files were too large to include (listed in manifest.json).",
        download: "Download",
        keptUntil: "Available until {{date}}",
        requested: "Requested {{date}}",
        sizeKb: "{{size}} KB",
        sizeMb: "{{size}} MB",
    },
    closure: {
        title: "Close the account",
        body: "Closing gives you {{days}} days to change your mind. During that time everything keeps working, including the POS. After that, every record, file and user of this business is deleted permanently and cannot be recovered.",
        advice: "Export your data first if you may need it later.",
        start: "Close the account…",
        dialogTitle: "Close this business account?",
        dialogBody: "Everything will be deleted permanently on {{date}}. Until then you can cancel.",
        reason: "Why are you closing? (required)",
        confirm: "Type the business web address to confirm: {{slug}}",
        submit: "Close the account",
        cancel: "Keep the account",
        closing: "This business will be closed and its data deleted permanently on {{date}}.",
        closingOwner: "You can cancel until then.",
        cancelClosure: "Cancel closing",
        cancelled: "The account will stay open.",
        requestedOk: "The account will be closed on {{date}}.",
        view: "Details",
    },
};
//# sourceMappingURL=account.js.map